export var QuestionMessageSubject;
(function (QuestionMessageSubject) {
    QuestionMessageSubject["UserRegistration"] = "user_registration";
    QuestionMessageSubject["IqosInformation"] = "iqos_information";
    QuestionMessageSubject["HowToUseIqos"] = "how_to_use_iqos";
    QuestionMessageSubject["HowToCleanIqos"] = "how_to_clean_iqos";
    QuestionMessageSubject["IqosMalfunction"] = "iqos_malfunction";
    QuestionMessageSubject["InformationAboutHeets"] = "information_about_heets";
    QuestionMessageSubject["HowToCharge"] = "how_to_charge";
    QuestionMessageSubject["OrderIssues"] = "order_issues";
    QuestionMessageSubject["WhereToBuy"] = "where_to_buy";
    QuestionMessageSubject["Other"] = "other";
})(QuestionMessageSubject || (QuestionMessageSubject = {}));
